/* @jsx glam */
import glam from "glam";
import React from "react";

const Image = props => {
    const gutter = 2;

    return (
        <div
            css={{
                backgroundColor: "#eee",
                boxSizing: "border-box",
                display: "inline-block",
                margin: gutter,
                overflow: "hidden",
                paddingBottom: "15%",
                position: "relative",
                width: `calc(25% - ${gutter * 2}px)`,
                ":hover": {
                    opacity: 0.9
                }
            }}
            {...props}
        />
    );
};

export default Image;
